import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccSessionSpecialistSurveyResponse } from '@interfaces';
import { DeliveryAreaService } from '../../../../delivery-area.service';
import { DeliveryOverviewService } from '../../../delivery-overview.service';
import { getSetup } from './grid/get-setup';

export interface SpecialistFeedback extends AccSessionSpecialistSurveyResponse {
	accId: number,
	accName: string,
	entrepreneurPersonId: number,
	entrepreneurName: string,
	eventId: number,
	eventStartUTC: number,
}

@Component({
	selector: 'delivery-specialist-feedback-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './specialist-feedback-view.part.html',
})
export class DeliverySpecialistFeedbackViewPart {

	private readonly util = inject(UtilityService);
	private readonly pageService = inject(DeliveryOverviewService);
	private readonly areaService = inject(DeliveryAreaService);

	public setup = computed(() => getSetup(this.util, this.areaService));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public specialistFeedbacks = computed<SpecialistFeedback[]>(() => {
		const data = this.areaService.deliveryData();
		if (!data) return [];

		const eventById = this.util.array.toMap(data.events, e => e.eventId);
		const accById = this.util.array.toMap(data.accelerators, acc => acc.accId);
		const entByPersonId = this.util.array.toMap(data.allVentures.flatMap(v => v.entrepreneurs), ent => ent.personId);

		const specialistFeedbacks: SpecialistFeedback[] = [];

		data.accSurveysResponses.forEach(survey => {

			const event = eventById[survey.eventId]!;
			const acc = accById[survey.accId]!;
			const ent = entByPersonId[survey.entrepreneurPersonId]!;

			survey.topicSurveyResponses.flatMap(topicSurvey => topicSurvey.specialistSurveyResponses).forEach(specialistSurvey => {

				specialistFeedbacks.push({
					...specialistSurvey,
					accId: survey.accId,
					accName: acc.name,
					entrepreneurPersonId: survey.entrepreneurPersonId,
					entrepreneurName: ent.name,
					eventId: survey.eventId,
					eventStartUTC: event.startUTC,
				});
			});
		});

		return specialistFeedbacks;
	});
}